import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSourceMaps from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-source-maps.tsx";
import * as React from 'react';
export default {
  StepVerifyErrorTracking,
  StepUploadSourceMaps,
  React
};